<template>
	<v-container fluid tag="section" class="mt-4 bg-white border rounded shadow solicitud-apoyo-escolar">
		<v-row>
			<v-col cols="12" class="d-flex justify-center align-center apoyos-escolares-loading" v-if="loading">
				<v-progress-circular
					indeterminate
					color="primary"
					size="100"
				/>
			</v-col>

			<template v-else>
			<v-col cols="12" v-if="isEditing && folioSolicitud">
				<div class="folio-info-box mb-3">
					Folio de la solicitud: {{ folioSolicitud }}
				</div>
			</v-col>
			<v-col cols="12">
				<div class="d-flex flex-column flex-sm-row justify-space-between align-sm-center mb-6">
					<div>
						<template v-if="isEditing && folioSolicitud">
							<h1 class="text-h5 font-weight-bold mb-1">Actualización de solicitud de apoyo escolar</h1>
							<p class="mb-0 text-body-2 text-secondary">
								Actualiza la información de tu beneficiario.
							</p>
						</template>
						<template v-else>
							<h1 class="text-h5 font-weight-bold mb-1">Solicitud de apoyo escolar</h1>
							<p class="mb-0 text-body-2 text-secondary">
								Selecciona un tipo de apoyo y captura la información de un beneficiario.
							</p>
						</template>
					</div>
					<v-btn class="mt-4 mt-sm-0" color="secondary" outlined @click="onRegresar">
						<v-icon left>mdi-arrow-left</v-icon>
						Regresar
					</v-btn>
				</div>
			</v-col>

			<v-col cols="12" v-if="observaciones">
				<v-card outlined class="section-card mb-4">
					<v-card-text>
						<div class="font-weight-bold">MOTIVO DEL RECHAZO:</div>
						<div class="text-danger">{{ observaciones }}</div>
					</v-card-text>
				</v-card>
			</v-col>
			
			<v-col cols="12">
				<v-card outlined class="section-card">
					<v-card-title class="section-card__title">Beneficiario</v-card-title>
					<v-card-text>
						<v-row>
							<v-col cols="12" md="6">
								<v-radio-group v-model="tipoApoyoSeleccionado" row hide-details>
									<v-radio
										v-for="tipo in tiposBeneficiariosDisponibles"
										:key="tipo.id"
										:label="tipo.descripcion"
										:value="tipo.id"
									/>
								</v-radio-group>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>

			<v-col cols="12" v-if="tipoApoyoSeleccionado">
				<v-card outlined class="section-card">
					<v-card-title class="section-card__title">Información del beneficiario</v-card-title>
					<v-card-text>
						<v-row>
							<v-col cols="12">
								<v-card class="beneficiary-card" outlined>
									
									<v-card-text>
										<v-row>
											<v-col cols="12" md="3">
												<v-text-field
													v-model="beneficiario.nombre"
													@input="beneficiario.nombre = beneficiario.nombre.toUpperCase()"
													label="Nombre"
													:disabled="camposBloqueadosTipoTrabajador"
													outlined
													dense
												/>
											</v-col>
											<v-col cols="12" md="3">
												<v-text-field
													v-model="beneficiario.apellido_paterno"
													@input="beneficiario.apellido_paterno = beneficiario.apellido_paterno.toUpperCase()"
													label="Apellido paterno"
													:disabled="camposBloqueadosTipoTrabajador"
													outlined
													dense
												/>
											</v-col>
											<v-col cols="12" md="3">
												<v-text-field
													v-model="beneficiario.apellido_materno"
													@input="beneficiario.apellido_materno = beneficiario.apellido_materno.toUpperCase()"
													label="Apellido materno"
													:disabled="camposBloqueadosTipoTrabajador"
													outlined
													dense
												/>
											</v-col>
											<v-col cols="12" md="3">
												<v-text-field
													v-model="beneficiario.curp"
													@input="beneficiario.curp = beneficiario.curp.toUpperCase()"
													label="CURP"
													maxlength="18"
													counter="18"
													:disabled="camposBloqueadosTipoTrabajador"
													outlined
													dense
												/>
											</v-col>
											<v-col cols="12" md="3">
												<v-select
													v-model="beneficiario.parentesco"
													:items="parentescosDisponibles"
													item-text="descripcion"
													item-value="id"
													label="Parentesco"
													:disabled="camposBloqueadosTipoTrabajador"
													outlined
													dense
												/>
											</v-col>
											<v-col cols="12" md="3">
												<v-select
													v-model="beneficiario.nivel_escolar"
													:items="nivelesEducativos"
													item-text="descripcion"
													item-value="id"
													label="Nivel escolar"
													outlined
													dense
												/>
											</v-col>
										</v-row>

										<div class="mt-2" v-if="muestraPromedio">
											<div class="text-subtitle-2 font-weight-medium mb-2">
												¿Tiene promedio de 9 o superior en su último ciclo escolar? *
											</div>
											<v-radio-group
												v-model="beneficiario.promedio_nueve"
												row
												hide-details
											>
												<v-radio :value="true" label="Sí" />
												<v-radio :value="false" label="No" />
											</v-radio-group>

											<v-row v-if="beneficiario.promedio_nueve === true" class="mt-2">
												<v-col cols="12" md="6">
													<v-text-field
														v-model="beneficiario.promedio_ultimo_ciclo"
														label="Promedio del último ciclo escolar *"
														placeholder="Ej. 9.5"
														hint="Ingrese el promedio (mínimo 9.0)"
														persistent-hint
														type="number"
														step="0.1"
														min="9"
														max="10"
														outlined
														dense
													/>
												</v-col>
											</v-row>
										</div>

										<div class="mt-4" v-if="beneficiario.nivel_escolar">
											<h3 class="subtitle-1 mb-2">Documentos requeridos</h3>

											<div v-if="cargandoDocumentos" class="py-4 text-center">
												<v-progress-circular indeterminate color="primary" size="32" />
											</div>

											<v-alert
												v-else-if="errorRequisitos"
												type="error"
												dense
												outlined
												class="mb-0"
											>
												{{ errorRequisitos }}
											</v-alert>

											<v-simple-table v-else-if="documentosRequeridos.length" dense class="documentos-table">
												<thead>
													<tr>
														<th>Documento</th>
														<th>Archivo</th>
														<th class="text-center" width="180">Acciones</th>
													</tr>
												</thead>
												<tbody>
													<tr v-for="doc in documentosRequeridos" :key="doc.documento_apoyo_id">
														<td class="font-weight-medium">
															{{ doc.descripcion }} *
															<div class="text-caption text--secondary font-weight-regular">Máximo 5 MB (PDF)</div>
														</td>
														<td>
															<span v-if="getArchivoDocumento(doc.documento_apoyo_id)" class="text-truncate d-inline-block archivo-nombre">
																<v-icon small color="red" class="mr-1">mdi-file-pdf-box</v-icon>
																{{ getArchivoDocumento(doc.documento_apoyo_id).name }}
																<span class="text-caption text--secondary ml-1">
																	({{ formatFileSize(getArchivoDocumento(doc.documento_apoyo_id).size) }})
																</span>
															</span>
															<span v-else-if="tieneDocumentoPrevio(doc.documento_apoyo_id)" class="success--text">
																Archivo cargado previamente
															</span>
															<span v-else class="text--secondary">Sin archivo</span>
														</td>
														<td class="text-center">
															<input
																:id="'file-input-doc-' + doc.documento_apoyo_id"
																type="file"
																accept=".pdf"
																style="display: none"
																@change="onFileDocumento($event, doc.documento_apoyo_id)"
															/>
															<div class="d-flex justify-center align-center" style="gap: 6px;">
																<v-btn
																	small
																	depressed
																	color="primary"
																	class="white--text"
																	:title="getArchivoDocumento(doc.documento_apoyo_id) ? 'Reemplazar archivo' : 'Subir archivo'"
																	@click="triggerFileDocumento(doc.documento_apoyo_id)"
																>
																	<v-icon left small>{{ getArchivoDocumento(doc.documento_apoyo_id) ? 'mdi-file-replace' : 'mdi-upload' }}</v-icon>
																	{{ getArchivoDocumento(doc.documento_apoyo_id) ? 'Reemplazar' : 'Subir' }}
																</v-btn>
																<v-btn
																	v-if="tieneDocumentoPrevio(doc.documento_apoyo_id) && !combinacionCambio"
																	small
																	depressed
																	color="info"
																	class="white--text"
																	title="Ver archivo previo"
																	@click="verDocumentoPrevio(doc.documento_apoyo_id)"
																>
																	<v-icon left small>mdi-eye</v-icon>
																	Ver
																</v-btn>
																<v-btn
																	v-if="getArchivoDocumento(doc.documento_apoyo_id)"
																	small
																	depressed
																	color="error"
																	class="white--text"
																	title="Quitar archivo"
																	@click="quitarArchivoDocumento(doc.documento_apoyo_id)"
																>
																	<v-icon left small>mdi-delete</v-icon>
																	Quitar
																</v-btn>
															</div>
														</td>
													</tr>
												</tbody>
											</v-simple-table>
										</div>
									</v-card-text>
								</v-card>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>

			<v-col cols="12" class="d-flex justify-end" v-if="tipoApoyoSeleccionado">
				<v-btn
					color="primary"
					large
					:disabled="guardandoSolicitud"
					:loading="guardandoSolicitud"
					@click="isEditing ? submitUpdateRequest() : submitRequest()"
				>
					<v-icon left>{{ isEditing ? 'mdi-content-save-edit-outline' : 'mdi-content-save-outline' }}</v-icon>
					{{ isEditing ? 'Actualizar solicitud' : 'Guardar solicitud' }}
				</v-btn>
			</v-col>
			</template>
		</v-row>

		<v-snackbar
			v-model="snackbar.show"
			:color="snackbar.color"
			timeout="3500"
		>
			{{ snackbar.text }}
		</v-snackbar>
	</v-container>
</template>

<script>
import { mapState } from 'vuex'

const crearBeneficiario = (tipoApoyo, key) => ({
	key,
	tipo_apoyo: tipoApoyo,
	nombre: '',
	apellido_paterno: '',
	apellido_materno: '',
	curp: '',
	nivel_escolar: '',
	parentesco: '',
	promedio_nueve: null,
	promedio_ultimo_ciclo: '',
})

export default {
	props: {
		tiene_apoyo_trabajador: {
			type: Boolean,
			default: null,
		},
		datos_empleado: {
			type: Object,
			default: null,
		},
        id_apoyo_escolar: {
            type: [String, Number],
            default: null,
        },
		datos_apoyo_escolar_editar: {
			type: Object,
			default: null,
		},
        observaciones: {
            type: String,
            default: null,
        },
		configuracion_apoyos_tipo_trabajador: {
			type: Object,
			default: () => ({
				max_solicitudes_trabajador: 0,
				max_solicitudes_hijo: 0,
			}),
		},
		conteo_apoyos_por_tipo: {
			type: Object,
			default: () => ({
				trabajador: 0,
				hijo: 0,
			}),
		},
	},
	data () {
		return {
            tieneApoyoTrabajador: this.tiene_apoyo_trabajador,
			loading: true,
			tipoApoyoSeleccionado: null,
			nivelesEducativos: [],
			parentescos: [],
			tiposBeneficiarios: [],
			beneficiario: crearBeneficiario(null, 'beneficiario'),
			folioSolicitud: null,
			isHydratingEditData: false,
			documentosRequeridos: [],
			archivosPorDocumento: {},
			documentosPrevios: {},
			cargandoDocumentos: false,
			errorRequisitos: null,
			requierePromedioRegla: false,
			combinacionOriginal: null,
			guardandoSolicitud: false,
			// Debe coincidir con max_size 5120 KB del API (ApiEmpleadosApoyosEscolaresController).
			maxPdfBytes: 5 * 1024 * 1024,
			snackbar: {
				show: false,
				text: '',
				color: 'success',
			},
		}
	},
	computed: {
		...mapState(['user', 'token', 'baseUrl']),
		camposBloqueadosTipoTrabajador () {
			return String(this.tipoApoyoSeleccionado) === '1'
		},
		parentescosDisponibles () {
			if (this.camposBloqueadosTipoTrabajador) {
				return this.parentescos
			}

			return this.parentescos.filter((item) => ['1', '3'].includes(String(item.id)))
		},
		tiposBeneficiariosDisponibles () {
			const maxTrabajador = Number(this.configuracion_apoyos_tipo_trabajador.max_solicitudes_trabajador || 0)
			const maxHijo = Number(this.configuracion_apoyos_tipo_trabajador.max_solicitudes_hijo || 0)
			const totalTrabajador = Number(this.conteo_apoyos_por_tipo.trabajador || 0)
			const totalHijo = Number(this.conteo_apoyos_por_tipo.hijo || 0)
			const tipoOriginal = this.combinacionOriginal ? String(this.combinacionOriginal.tipo_beneficiario_id) : null

			return this.tiposBeneficiarios.filter((tipo) => {
				const tipoId = String(tipo.id)
				if (this.isEditing && tipoOriginal === tipoId) {
					return true
				}

				if (tipoId === '1') {
					return totalTrabajador < maxTrabajador
				}

				if (tipoId === '2') {
					return totalHijo < maxHijo
				}

				return true
			})
		},
		isEditing () {
			return Boolean(this.id_apoyo_escolar && this.datos_apoyo_escolar_editar)
		},
		combinacionCambio () {
			if (!this.combinacionOriginal || !this.isEditing) {
				return false
			}

			return String(this.tipoApoyoSeleccionado) !== String(this.combinacionOriginal.tipo_beneficiario_id)
				|| String(this.beneficiario.nivel_escolar) !== String(this.combinacionOriginal.nivel_educativo_id)
		},
		muestraPromedio () {
			return this.requierePromedioRegla && !this.camposBloqueadosTipoTrabajador
		},
	},
	watch: {
		tipoApoyoSeleccionado (value) {
			if (this.isHydratingEditData) {
				return
			}

			this.beneficiario = crearBeneficiario(value, 'beneficiario')
			if (String(value) === '1') {
				this.aplicarDatosEmpleadoTipoTrabajador()
			}
			this.resetDocumentosLocales()
			this.cargarRequisitosDocumentos()
		},
		'beneficiario.nivel_escolar' (value) {
			if (this.isHydratingEditData) {
				return
			}

			this.resetDocumentosLocales()
			if (value) {
				this.cargarRequisitosDocumentos()
			} else {
				this.documentosRequeridos = []
				this.errorRequisitos = null
				this.requierePromedioRegla = false
			}
		},
		'beneficiario.parentesco' () {
			if (this.isHydratingEditData || !this.beneficiario.nivel_escolar) {
				return
			}

			this.resetDocumentosLocales()
			this.cargarRequisitosDocumentos()
		},
		'beneficiario.promedio_nueve' (value) {
			if (value !== true) {
				this.beneficiario.promedio_ultimo_ciclo = ''
			}
		},
		datos_apoyo_escolar_editar: {
			handler () {
				if (!this.loading) {
					this.inicializarDatosEdicion()
				}
			},
			deep: true,
		},
	},
	async created () {
		await this.cargarNivelesEducativos()
		await this.cargarParentescos()
		await this.cargarTiposBeneficiarios()
		this.inicializarDatosEdicion()
		this.loading = false
	},
	methods: {
		aplicarDatosEmpleadoTipoTrabajador () {
			const datosEmpleado = this.datos_empleado || {}
			this.beneficiario = {
				...this.beneficiario,
				nombre: String(datosEmpleado.nombre || '').toUpperCase(),
				apellido_paterno: String(datosEmpleado.ap_paterno || '').toUpperCase(),
				apellido_materno: String(datosEmpleado.ap_materno || '').toUpperCase(),
				curp: String(datosEmpleado.curp || '').toUpperCase(),
				parentesco: "2",
			}
		},

		async cargarNivelesEducativos () {
			const response = await this.$http.get('apoyos-escolares/get-niveles-educativos')
			this.nivelesEducativos = response.data.data
		},
		async cargarParentescos () {
			const response = await this.$http.get('apoyos-escolares/get-tipos-parentesco')
			this.parentescos = response.data.data
		},
		async cargarTiposBeneficiarios () {
			const response = await this.$http.get('apoyos-escolares/get-tipos-beneficiarios')
			this.tiposBeneficiarios = response.data.data

			if (!this.tiposBeneficiariosDisponibles.length) {
				return
			}

			this.tipoApoyoSeleccionado = this.tiposBeneficiariosDisponibles[0].id
		},

		onRegresar (solicitudExitosa = false) {
				this.$emit('regresar', { solicitudExitosa })
		},
		solicitarApoyoEscolar: async function (form) {
			return await this.$http.post('post-empleado-apoyos-escolares', form)
		},
		actualizarApoyoEscolar: async function (form) {
			return await this.$http.post('post-empleado-apoyos-escolares-editar', form)
		},
		resetDocumentosLocales () {
			this.archivosPorDocumento = {}
			if (this.combinacionCambio || !this.isEditing) {
				this.documentosPrevios = {}
			}
		},
		async cargarRequisitosDocumentos () {
			if (!this.tipoApoyoSeleccionado || !this.beneficiario.nivel_escolar) {
				this.documentosRequeridos = []
				this.errorRequisitos = null
				this.requierePromedioRegla = false
				return
			}

			this.cargandoDocumentos = true
			this.errorRequisitos = null

			try {
				const response = await this.$http.get('apoyos-escolares/obtener-requisitos-documentos', {
					params: {
						tipo_beneficiario_id: this.tipoApoyoSeleccionado,
						nivel_educativo_id: this.beneficiario.nivel_escolar,
						parentesco_id: this.beneficiario.parentesco || undefined,
					},
				})

				if (!response.data || !response.data.response) {
					this.documentosRequeridos = []
					this.requierePromedioRegla = false
					this.errorRequisitos = (response.data && response.data.message)
						|| 'No hay documentos configurados para esta combinación. Favor de contactar al administrador del sistema.'
					return
				}

				this.documentosRequeridos = response.data.data.documentos || []
				this.requierePromedioRegla = Boolean(response.data.data.requiere_promedio)

				if (!this.muestraPromedio) {
					this.beneficiario.promedio_nueve = null
					this.beneficiario.promedio_ultimo_ciclo = ''
				}

				if (this.isEditing && !this.combinacionCambio) {
					await this.cargarDocumentosExistentes()
				}
			} catch (error) {
				this.documentosRequeridos = []
				this.requierePromedioRegla = false
				this.errorRequisitos = 'No se pudieron cargar los documentos requeridos.'
			} finally {
				this.cargandoDocumentos = false
			}
		},
		async cargarDocumentosExistentes () {
			if (!this.id_apoyo_escolar) {
				return
			}

			try {
				const response = await this.$http.get('apoyos-escolares/obtener-documentos-apoyo-escolar/' + this.id_apoyo_escolar)
				if (!response.data || !response.data.response) {
					return
				}

				const documentosPrevios = {}
				;(response.data.data || []).forEach((documento) => {
					documentosPrevios[String(documento.documento_apoyo_id)] = documento
				})
				this.documentosPrevios = documentosPrevios
			} catch (error) {
				this.documentosPrevios = {}
			}
		},
		inicializarDatosEdicion () {
			if (!this.isEditing) {
				if (String(this.tipoApoyoSeleccionado) === '1') {
					this.aplicarDatosEmpleadoTipoTrabajador()
				}
				this.folioSolicitud = null
				this.combinacionOriginal = null
				this.cargarRequisitosDocumentos()
				return
			}

			const datosEdicion = this.datos_apoyo_escolar_editar || {}
			this.isHydratingEditData = true
			this.folioSolicitud = datosEdicion.folio || null

			const tipoBeneficiario = this.tiposBeneficiarios.find((tipo) => {
				return String(tipo.descripcion || '').toUpperCase() === String(datosEdicion.tipo_solicitante || '').toUpperCase()
			})

			if (tipoBeneficiario) {
				this.tipoApoyoSeleccionado = tipoBeneficiario.id
			}

			const nivelEscolar = this.nivelesEducativos.find((nivel) => {
				return String(nivel.descripcion || '').toUpperCase() === String(datosEdicion.nivel_escolar || '').toUpperCase()
					|| String(nivel.id) === String(datosEdicion.nivel_escolar)
			})

			const parentesco = this.parentescos.find((item) => {
				return String(item.id) === String(datosEdicion.parentesco) ||
					String(item.descripcion || '').toUpperCase() === String(datosEdicion.parentesco || '').toUpperCase()
			})

			this.beneficiario = {
				...crearBeneficiario(this.tipoApoyoSeleccionado, 'beneficiario'),
				nombre: datosEdicion.nombre || '',
				apellido_paterno: datosEdicion.ap_paterno || '',
				apellido_materno: datosEdicion.ap_materno || '',
				curp: String(datosEdicion.curp || '').toUpperCase(),
				nivel_escolar: nivelEscolar ? nivelEscolar.id : '',
				parentesco: parentesco ? parentesco.id : '',
				promedio_nueve: String(datosEdicion.cumple_promedio) === '1'
					? true
					: String(datosEdicion.cumple_promedio) === '0'
						? false
						: null,
				promedio_ultimo_ciclo: datosEdicion.promedio_ultimo_ciclo !== null && datosEdicion.promedio_ultimo_ciclo !== ''
					? String(datosEdicion.promedio_ultimo_ciclo)
					: '',
			}

			this.combinacionOriginal = {
				tipo_beneficiario_id: this.tipoApoyoSeleccionado,
				nivel_educativo_id: this.beneficiario.nivel_escolar,
			}

			this.$nextTick(async () => {
				this.isHydratingEditData = false
				await this.cargarRequisitosDocumentos()
			})
		},
		triggerFileDocumento (documentoApoyoId) {
			const input = document.getElementById('file-input-doc-' + documentoApoyoId)
			if (input) {
				input.click()
			}
		},
		onFileDocumento (event, documentoApoyoId) {
			const files = Array.from(event.target.files || [])
			event.target.value = ''

			if (!files.length) {
				return
			}

			const file = files[0]
			if (file.type !== 'application/pdf' && !/\.pdf$/i.test(file.name || '')) {
				this.showSnackbar('Solo se permiten archivos PDF.', 'warning')
				return
			}

			if (file.size > this.maxPdfBytes) {
				this.showSnackbar(
					'El archivo supera el tamaño máximo de 5 MB. Reduce o comprime el PDF e intenta de nuevo.',
					'warning'
				)
				return
			}

			this.$set(this.archivosPorDocumento, String(documentoApoyoId), file)
		},
		quitarArchivoDocumento (documentoApoyoId) {
			this.$delete(this.archivosPorDocumento, String(documentoApoyoId))
		},
		getArchivoDocumento (documentoApoyoId) {
			return this.archivosPorDocumento[String(documentoApoyoId)] || null
		},
		tieneDocumentoPrevio (documentoApoyoId) {
			return Boolean(this.documentosPrevios[String(documentoApoyoId)])
		},
		verDocumentoPrevio (documentoApoyoId) {
			if (!this.id_apoyo_escolar) {
				this.showSnackbar('No se encontró el identificador del apoyo escolar.', 'warning')
				return
			}

			// window.open no puede enviar la cabecera Authorization: el token va
			// como query string, que es el modo que acepta el trait Auth.
			window.open(
				this.baseUrl + 'apoyos-escolares/descargar-documento-anexo/' + this.id_apoyo_escolar + '/' + documentoApoyoId + '?token=' + this.token,
				'_blank'
			)
		},
		appendDocumentosFormData (form) {
			Object.keys(this.archivosPorDocumento).forEach((documentoApoyoId) => {
				const archivo = this.archivosPorDocumento[documentoApoyoId]
				if (archivo) {
					form.append('archivos[' + documentoApoyoId + ']', archivo)
				}
			})
		},
		obtenerDescripcionNivelEscolar (nivelEscolarId) {
			const nivelSeleccionado = this.nivelesEducativos.find((nivel) => {
				return String(nivel.id) === String(nivelEscolarId)
			})

			return nivelSeleccionado ? String(nivelSeleccionado.descripcion || '') : ''
		},
		buildPayload () {
			const grado = this.obtenerDescripcionNivelEscolar(this.beneficiario.nivel_escolar)

			const payload = {
				id_empleado: this.user.id_empleado,
				id_apoyo_escolar: this.id_apoyo_escolar,
				folio: this.folioSolicitud,
				tipo_apoyo: this.tipoApoyoSeleccionado,
				nombre: this.beneficiario.nombre,
				apellido_paterno: this.beneficiario.apellido_paterno,
				apellido_materno: this.beneficiario.apellido_materno,
				curp: this.beneficiario.curp,
				nivel_escolar: this.beneficiario.nivel_escolar,
				grado,
				parentesco: this.beneficiario.parentesco,
				cumple_promedio: this.muestraPromedio ? this.beneficiario.promedio_nueve : null,
				promedio_ultimo_ciclo: this.muestraPromedio && this.beneficiario.promedio_nueve === true
					? this.beneficiario.promedio_ultimo_ciclo
					: null,
				reemplazar_documentos: this.isEditing && this.combinacionCambio,
			}

			return payload
		},
		validarBeneficiario (beneficiario) {
			if (!beneficiario.nombre.trim()) {
				this.showSnackbar('El nombre es obligatorio.', 'error')
				return false
			}

			if (!beneficiario.apellido_paterno.trim()) {
				this.showSnackbar('El apellido paterno es obligatorio.', 'error')
				return false
			}

			if (!beneficiario.curp.trim()) {
				this.showSnackbar('La CURP es obligatoria.', 'error')
				return false
			}

			if (beneficiario.curp.trim().length < 18) {
				this.showSnackbar('La CURP debe tener al menos 18 caracteres.', 'error')
				return false
			}

			if (!beneficiario.nivel_escolar) {
				this.showSnackbar('Selecciona el nivel escolar.', 'error')
				return false
			}

			if (!beneficiario.parentesco) {
				this.showSnackbar('Selecciona el parentesco.', 'error')
				return false
			}

			if (this.muestraPromedio && beneficiario.promedio_nueve === null) {
				this.showSnackbar('Indica si tiene promedio de 9 o superior.', 'error')
				return false
			}

			if (this.muestraPromedio && beneficiario.promedio_nueve === true) {
				const promedio = parseFloat(beneficiario.promedio_ultimo_ciclo)
				if (!beneficiario.promedio_ultimo_ciclo || Number.isNaN(promedio)) {
					this.showSnackbar('Captura el promedio del último ciclo escolar.', 'error')
					return false
				}
				if (promedio < 9) {
					this.showSnackbar('El promedio del último ciclo escolar debe ser mínimo 9.0.', 'error')
					return false
				}
				if (promedio > 10) {
					this.showSnackbar('El promedio del último ciclo escolar no puede ser mayor a 10.', 'error')
					return false
				}
			}

			if (this.errorRequisitos) {
				this.showSnackbar(this.errorRequisitos, 'error')
				return false
			}

			if (!this.documentosRequeridos.length) {
				this.showSnackbar('No hay documentos configurados para esta combinación. Favor de contactar al administrador del sistema.', 'error')
				return false
			}

			for (const documento of this.documentosRequeridos) {
				const documentoApoyoId = String(documento.documento_apoyo_id)
				const tieneArchivoNuevo = Boolean(this.archivosPorDocumento[documentoApoyoId])
				const tieneArchivoPrevio = !this.combinacionCambio && Boolean(this.documentosPrevios[documentoApoyoId])

				if (!tieneArchivoNuevo && !tieneArchivoPrevio) {
					this.showSnackbar('Adjunta el documento: ' + documento.descripcion, 'error')
					return false
				}
			}

			return true
		},
		submitRequest () {
			if (this.guardandoSolicitud) {
				return
			}

			if (!this.tipoApoyoSeleccionado) {
				this.showSnackbar('Selecciona un tipo de apoyo.', 'warning')
				return
			}

			const isValid = this.validarBeneficiario(this.beneficiario)
			if (!isValid) {
				return
			}

			const mensaje = '¿Estas seguro de guardar la solicitud de apoyo escolar?'
			const mensaje_advertencia = ''

			this.$swal({
				className: 'text-center',
				title: mensaje,
				text: mensaje_advertencia,
				icon: 'warning',
				allowEscapeKey: false,
				allowOutsideClick: false,
				reverseButtons: true,
				buttons: ['Cancelar', 'Aceptar'],
			}).then(async (value) => {
				if (!value || this.guardandoSolicitud) {
					return
				}

				this.guardandoSolicitud = true

				try {
					const payload = [this.buildPayload()]

					let form = new FormData()
					form.append('payload', JSON.stringify(payload))
					this.appendDocumentosFormData(form)

					let response = await this.solicitarApoyoEscolar(form)
					if (response.data && response.data.response) {
						this.$toasted.success(response.data.message || 'SOLICITUD GUARDADA CORRECTAMENTE')
						this.onRegresar(true)
					} else {
						this.$swal({
							title: (response.data && (response.data.error || response.data.message)) || 'No se pudo guardar la solicitud',
							text: '',
							icon: 'error',
							button: 'Aceptar',
						})
					}
				} catch (error) {
					this.$swal({
						title: this.obtenerMensajeErrorApi(error, 'Ocurrió un problema al procesar la solicitud'),
						text: '',
						icon: 'error',
						button: 'Aceptar',
					})
				} finally {
					this.guardandoSolicitud = false
				}
			})
		},
		submitUpdateRequest () {
			if (this.guardandoSolicitud) {
				return
			}

			if (!this.tipoApoyoSeleccionado) {
				this.showSnackbar('Selecciona un tipo de apoyo.', 'warning')
				return
			}

			const isValid = this.validarBeneficiario(this.beneficiario)
			if (!isValid) {
				return
			}

			const mensaje = '¿Estas seguro de actualizar la solicitud de apoyo escolar?'
			const mensaje_advertencia = ''

			this.$swal({
				className: 'text-center',
				title: mensaje,
				text: mensaje_advertencia,
				icon: 'warning',
				allowEscapeKey: false,
				allowOutsideClick: false,
				reverseButtons: true,
				buttons: ['Cancelar', 'Aceptar'],
			}).then(async (value) => {
				if (!value || this.guardandoSolicitud) {
					return
				}

				this.guardandoSolicitud = true

				try {
					const payload = [this.buildPayload()]

					let form = new FormData()
					form.append('payload', JSON.stringify(payload))
					this.appendDocumentosFormData(form)

					let response = await this.actualizarApoyoEscolar(form)
					if (response.data && response.data.response) {
						this.$toasted.success(response.data.message || 'SOLICITUD ACTUALIZADA CORRECTAMENTE')
						this.onRegresar(true)
					} else {
						this.$swal({
							title: (response.data && (response.data.error || response.data.message)) || 'No se pudo actualizar la solicitud',
							text: '',
							icon: 'error',
							button: 'Aceptar',
						})
					}
				} catch (error) {
					this.$swal({
						title: this.obtenerMensajeErrorApi(error, 'Ocurrió un problema al actualizar la solicitud'),
						text: '',
						icon: 'error',
						button: 'Aceptar',
					})
				} finally {
					this.guardandoSolicitud = false
				}
			})
		},
		obtenerMensajeErrorApi (error, fallback) {
			const data = error && error.response && error.response.data
			if (!data) {
				return fallback
			}

			if (typeof data === 'string' && data.trim()) {
				return data.trim()
			}

			const mensaje = data.message || data.error
			if (typeof mensaje === 'string' && mensaje.trim()) {
				return mensaje.trim()
			}

			return fallback
		},
		showSnackbar (text, color = 'success') {
			this.snackbar.text = text
			this.snackbar.color = color
			this.snackbar.show = true
		},
		formatFileSize (bytes) {
			if (!bytes) return '0 Bytes'

			const k = 1024
			const sizes = ['Bytes', 'KB', 'MB', 'GB']
			const i = Math.floor(Math.log(bytes) / Math.log(k))
			return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
		},
	},
}
</script>

<style scoped>
.solicitud-apoyo-escolar {
	min-height: calc(100vh - 140px);
}

.apoyos-escolares-loading {
	min-height: calc(118.8vh - 260px);
}

.section-card {
	border-radius: 12px;
}

.section-card__title {
	word-break: break-word;
}

.beneficiary-card {
	border-radius: 10px;
	background: #fafafa;
}

.beneficiary-card__title {
	background: #f5f7fa;
	word-break: break-word;
}

.folio-info-box {
	padding: 10px 14px;
	border-radius: 8px;
	background: #f5f7fa;
	font-weight: 600;
	color: #2c3e50;
}

.documentos-table {
	border: 1px solid #e0e0e0;
	border-radius: 8px;
	overflow: hidden;
}

.archivo-nombre {
	max-width: 320px;
	vertical-align: middle;
}
</style>
